import { useQuery } from '@biletiniz/apollo';
import { CHECK_SERVER_STATUS } from './gql';

export const useCheckServerStatus = () => {
  const { data, error, loading } = useQuery(CHECK_SERVER_STATUS, {
    fetchPolicy: 'no-cache',
    context: {
      headers: {
        authorization: null, // Server status check doesn't need authentication
      },
    },
  });
  return {
    isWorking: data?.checkServerStatus.isWorking,
    registerADsWorking: data?.checkServerStatus.registerADsWorking,
    loading,
    error: error?.message,
  };
};
